var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { KeyboardArrowDownOutlined } from '@mui/icons-material';
import { Paper, createTheme as createV5Theme } from '@mui/material';
import { Caption } from '../components/Typography';
const spacing = 8;
const OutlinedPaper = (_a) => {
    var props = __rest(_a, []);
    return _jsx(Paper, Object.assign({}, props, { variant: 'outlined' }));
};
export const modernV5 = createV5Theme({
    palette: {
        default: {
            main: '#333333',
            contrastText: '#ffffff',
        },
        primary: {
            main: '#1471EB',
            light: '#9DBBE7',
            dark: '#0A56C2',
        },
        secondary: {
            main: '#ffffff',
        },
        error: {
            main: '#DC3545',
            light: '#F8D7DA',
        },
        warning: {
            main: '#FFC107',
            light: '#FFF3CD',
        },
        success: {
            main: '#28A745',
            light: '#D4EDDA',
        },
        background: {
            message: {
                primary: '#f5f5f5',
                secondary: '#E1F5FD',
                unread: '#82D5F8',
            },
            user: {
                action: 'rgba(0, 0, 0, 0.35)',
            },
            formAnswerStatus: {
                noAction: '#d3d3d3',
                approved: '#4CAF50',
                rejected: '#f44336',
                submitted: '#00BCD4',
            },
        },
        // divider: '#E0E0E0',
        text: {
            primary: '#333333',
            secondary: '#8A898E',
        },
    },
    typography: {
        fontSize: 16,
        fontFamily: 'Inter,Arial,sans-serif',
        'uikit-h1': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '36px',
            fontWeight: 400,
            lineHeight: '44px',
        },
        'uikit-h2': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '28px',
            fontWeight: 500,
            lineHeight: '34px',
        },
        'uikit-h3': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '22px',
            fontWeight: 500,
            lineHeight: '27px',
        },
        'uikit-subheader1': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '22px',
        },
        'uikit-subheader2': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '19px',
        },
        'uikit-subheader3': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '17px',
        },
        'uikit-body1': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '22px',
        },
        'uikit-body2': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
        },
        'uikit-button1': {
            fontSize: '17px',
            fontWeight: 500,
            lineHeight: '20.57px',
        },
        'uikit-button2': {
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: '18.15px',
        },
        'uikit-caption': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '18px',
        },
        'uikit-link1': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '19px',
        },
        'uikit-link2': {
            fontFamily: 'Inter,Arial,sans-serif',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '17px',
        },
    },
    components: {
        MuiButton: {
            defaultProps: {
                color: 'default',
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    padding: `${spacing}px ${spacing * 2}px`,
                    fontWeight: 600,
                    minWidth: 'max-content',
                    textTransform: 'initial',
                },
                outlined: {
                    padding: `${spacing - 1}px ${spacing * 2 - 1}px`,
                },
            },
        },
        MuiCardHeader: {
            defaultProps: {
                titleTypographyProps: {
                    variant: 'body1',
                    noWrap: true,
                },
            },
            styleOverrides: {
                content: {
                    minWidth: 0,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    paddingInline: spacing * 3,
                    paddingBlockEnd: spacing * 2,
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    paddingTop: `${spacing}px !important`,
                    paddingBlock: spacing,
                    paddingInline: spacing * 3,
                    overflowY: 'auto',
                },
            },
        },
        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    fontFamily: 'Inter,Arial,sans-serif',
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '22px',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontFamily: 'Inter,Arial,sans-serif',
                    fontSize: '21px',
                    fontWeight: 500,
                    lineHeight: '27px',
                },
            },
        },
        MuiFilledInput: {
            defaultProps: {
                disableUnderline: true,
            },
            styleOverrides: {
                root: {
                    borderBottomLeftRadius: 8,
                    borderBottomRightRadius: 8,
                    overflow: 'hidden',
                },
            },
        },
        // MuiMenu: {
        //   defaultProps: {},
        //   styleOverrides: {
        //     list: {
        //       padding: spacing / 2,
        //     },
        //   },
        // },
        // MuiMenuItem: {
        //   styleOverrides: {
        //     root: {
        //       fontSize: '14px',
        //       fontWeight: 400,
        //       lineHeight: '16.94px',
        //       padding: `${spacing * 1.25}px ${spacing * 2}px`,
        //       borderRadius: 4,
        //       '&:hover': {
        //         backgroundColor: '#E7EFF9',
        //       },
        //       '&.Mui-focusVisible': {
        //         backgroundColor: '#E7EFF9',
        //       },
        //     },
        //   },
        // },
        MuiSelect: {
            defaultProps: {
                variant: 'standard',
                IconComponent: KeyboardArrowDownOutlined,
            },
        },
        MuiTable: {
            defaultProps: {
                size: 'small',
                stickyHeader: true,
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 600,
                },
            },
        },
        MuiTableContainer: {
            defaultProps: {
                component: OutlinedPaper,
            },
            styleOverrides: {
                root: {
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    position: 'relative',
                },
            },
        },
        MuiTableRow: {
            defaultProps: {
                hover: true,
            },
            styleOverrides: {
                root: {
                    cursor: 'pointer',
                },
            },
        },
        MuiTooltip: {
            defaultProps: {
                enterDelay: 500,
                enterNextDelay: 500,
            },
            styleOverrides: {
                tooltip: {
                    fontSize: '1em',
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    minWidth: 0,
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 32,
                },
            },
        },
        MuiListItemText: {
            defaultProps: {
                primaryTypographyProps: {
                    variant: 'body2',
                    noWrap: true,
                },
                secondaryTypographyProps: {
                    variant: 'caption',
                    noWrap: true,
                },
            },
            styleOverrides: {
                multiline: {
                    marginTop: 0,
                    marginBottom: 0,
                },
            },
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 2px 3px -1px rgb(0 0 0 / 75%), 0px -1px 1px -1px rgb(0 0 0 / 50%)',
                },
            },
        },
        MuiFormHelperText: {
            defaultProps: {
                component: Caption,
            },
        },
    },
    shape: {
        borderRadius: 8,
    },
});
